import React, { useContext } from "react"
import styled from "styled-components"
import Vimeo from "@u-wave/react-vimeo"
import { ThemeContext, LinkBox } from "Components"
import LinkedInIcon from "Static/icons/linkedin.svg"
import { theme } from "Theme"
import { GatsbyImage } from "gatsby-plugin-image"

const Wrapper = styled.div`
  background: white;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-width: ${({ image }) => (image ? theme.layout.base : "auto")};
  min-height: ${({ big }) => (big ? "400px" : "100px")};
  align-items: center;
  margin: 0 auto;
  box-shadow: ${theme.shadow.feature.small.default};
  border-left: 2px solid ${theme.colors.primary.base};

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    margin: 0 auto 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

export const Content = styled.div`
  display: block;
  padding: 2rem 1rem;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  border-color: ${({ mode }) => (mode === "light" ? theme.colors.white.base : theme.colors.black.base)};
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 3rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const TestimonialCard = styled.section`
  display: flex;
  flex-direction: column;
  text-align: left;
  border-radius: ${theme.borderRadius.ui};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  justify-content: space-between;
  margin: 0 auto;
  padding: 1rem;
`

const TestimonialVideo = styled.div`
  iframe {
    width: 100%;
    height: 200px;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const TestimonialContent = styled.div`
  margin: 1rem auto;
  display: grid;
  grid-template-rows: repeat(auto-fill, minmax(1fr, 100px));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-rows: repeat(auto-fill, minmax(1fr, 100px));
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-rows: repeat(auto-fill, minmax(1fr, 100px));
  }
  grid-gap: 1rem;
  .slider-frame {
    overflow: visible !important;
  }
`
export const TestimonialCopy = styled.p`
  display: block;
  position: relative;
  font-size: ${theme.fontSize.small};
  font-family: ${theme.fontFamily.qoute};
  font-style: italic;
  font-weight: normal;
  line-height: 1.3rem;
  margin: 0;
  text-align: center;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: center;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }

  &:before {
    content: "“";
    position: relative;
    color: #aaa;
    font-family: Arial;
    opacity: 0.2;
    top: 18px;
    left: 0;
    padding: 0 8px 0 0;
    font-size: 42px;
    font-weight: bold;
    display: inline;
    line-height: 0px;
  }

  &:after {
    content: "”";
    position: relative;
    color: #aaa;
    font-family: Arial;
    opacity: 0.2;
    top: 20px;
    left: 0;
    padding: 0 8px 0 0;
    font-size: 42px;
    font-weight: bold;
    display: inline;
    line-height: 0px;
  }
`

export const TestimonialAuthor = styled.div`
  font-family: ${theme.fontFamily.body};
  text-align: center;
  display: grid;
  grid-template-columns: 56px 1fr;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: 56px 1fr;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: 56px 1fr;
  }
  grid-gap: 12px;

  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: center;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const TestimonialAuthorAvatar = styled.div`
  position: relative;
  display: block;
  width: 100%;
  border-radius: ${theme.borderRadius.round};
  overflow: hidden;
  font-size: ${theme.fontSize.small};
  font-weight: bold;
  margin: 0;
  height: 56px;
  background: #ccc;
  img {
    margin: 0;
    width: 100%;
    height: auto;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: start;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
export const TestimonialAuthorDetails = styled.div`
  display: block;
  font-size: ${theme.fontSize.small};
  font-weight: bold;
  align-self: center;
  text-align: left;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
export const TestimonialAuthorName = styled.h5`
  display: block;
  font-size: ${theme.fontSize.smallish};
  margin: 0 0 4px 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: start;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  a img {
    width: 16px;
    height: 16px;
    margin: 0 3px 0 0;
  }
`
export const TestimonialAuthorTitle = styled.h5`
  display: block;
  font-size: ${theme.fontSize.xsmall};
  color: ${theme.colors.black.grey};
  margin: 0 0 4px 0;
  font-weight: normal;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: start;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
export const TestimonialAuthorCompany = styled.h5`
  display: block;
  font-size: ${theme.fontSize.xsmall};
  margin: 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-self: start;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const AvatarComponent = ({ data }) => {
  let exist = data.node.childrenFile.length > 0 ? true : false
  if (exist) {
    return (
      <GatsbyImage
        alt={`${data.node.name} | ${data.node.title} at ${data.node.company}`}
        title={`${data.node.name} | ${data.node.title} at ${data.node.company}`}
        objectFit="contain"
        objectPosition="50% 50%"
        image={data.node.childrenFile[0].childImageSharp.gatsbyImageData}
      />
    )
  } else {
    return <span></span>
  }
}

const SectionTestimonials = ({
  data,
  track,
  dark,
  big,

  image,
}) => {
  const { mode } = useContext(ThemeContext)

  return (
    <>
      <Wrapper image={image} mode={dark ? "dark" : mode} big={big}>
        <Content mode={dark ? "dark" : mode}>
          {data.video && (
            <TestimonialVideo>
              <Vimeo
                video={data.video}
                width={720}
                height={340}
                volume={0}
                background={false}
                controls={false}
                className="video-iframe"
              />
            </TestimonialVideo>
          )}
          <TestimonialContent>
            <TestimonialCopy>{data.node.testimonal}</TestimonialCopy>
            <TestimonialAuthor>
              <TestimonialAuthorAvatar>{data.node.gender && <AvatarComponent data={data} />}</TestimonialAuthorAvatar>
              <TestimonialAuthorDetails>
                {data.node.name && (
                  <TestimonialAuthorName>
                    {!data.node.linkedin && data.node.name}
                    {data.node.linkedin && (
                      <LinkBox
                        to={data.node.linkedin}
                        alt={`${data.node.name} - ${data.node.title} at ${data.node.company} on LinkedIn`}
                        title={`${data.node.name} - ${data.node.title} at ${data.node.company} on LinkedIn`}
                        track={track}
                        rel="nofollow noopener noreferrer">
                        <img
                          src={LinkedInIcon}
                          alt={`${data.node.name} - ${data.node.title} at ${data.node.company} on LinkedIn`}
                        />
                        {data.node.name}
                      </LinkBox>
                    )}
                  </TestimonialAuthorName>
                )}
                {data.node.title && <TestimonialAuthorTitle>{data.node.title}</TestimonialAuthorTitle>}
                {data.node.company && <TestimonialAuthorCompany>{data.node.company}</TestimonialAuthorCompany>}
              </TestimonialAuthorDetails>
            </TestimonialAuthor>
          </TestimonialContent>
        </Content>
      </Wrapper>
    </>
  )
}

export default SectionTestimonials
